import { Dialog } from 'primereact/dialog';
import { Dispatch, FC, SetStateAction, useEffect, useState, useTransition } from 'react';
import { ThreeDotLoader } from '../Fallback/ThreeDotsLoader';
import { Button } from 'primereact/button';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import { modalLessons } from '../../graphQLOperations/SkillResource';
import { SkillResourceGetLessonsQuery } from '../../graphQLOperations/__generated__/SkillResourceGetLessonsQuery.graphql';
import { Link } from 'react-router-dom';

interface Props {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  digitalLessonsQueryRef: PreloadedQuery<SkillResourceGetLessonsQuery, Record<string, unknown>>;
}

interface Url {
  englishUrl: string;
  spanishhUrl: string;
}

const DigitalLessonModal: FC<Props> = ({ visible, setVisible, digitalLessonsQueryRef }) => {
  const [loading, startTransition] = useTransition();
  const [url, setUrl] = useState<Url>();

  const { lessonSkills } = usePreloadedQuery<SkillResourceGetLessonsQuery>(
    modalLessons,
    digitalLessonsQueryRef as PreloadedQuery<SkillResourceGetLessonsQuery>,
  );

  useEffect(() => {
    startTransition(() => {
      lessonSkills?.nodes?.map(el => {
        setUrl({ englishUrl: el.lesson?.url ?? '', spanishhUrl: el.lesson?.spanishUrl ?? '' });
      });
    });
  }, [lessonSkills]);

  return (
    <Dialog
      closable
      visible={visible}
      onHide={() => setVisible(false)}
      className="tw-p-6"
      pt={{ content: { style: { paddingBottom: '24px' } } }}
    >
      <>
        {loading && <ThreeDotLoader dark />}

        <div className="tw-flex tw-flex-col tw-items-center tw-gap-4">
          <div className="tw-flex tw-flex-col tw-items-center tw-gap-1">
            <h1 className="tw-font-atkinson tw-text-2xl tw-text-neutral-950 tw-font-bold">Digital lessons </h1>
            <p className="tw-font-atkinson tw-text-lg tw-text-neutral-950">Select the language for your lessons</p>
          </div>
          <div className="tw-flex tw-flex-row tw-items-center tw-gap-1">
            {url?.englishUrl ? (
              <Link to={url.englishUrl} target="_blank" rel="noopener noreferrer">
                <Button label="English" className="nc_digital-lesson-button" />
              </Link>
            ) : (
              <Button label="English" className="nc_digital-lesson-button" disabled />
            )}
            {url?.spanishhUrl ? (
              <Link to={url?.spanishhUrl ?? ''} target="_blank" rel="noopener noreferrer">
                <Button label="Español" className="nc_digital-lesson-button" />
              </Link>
            ) : (
              <Button label="Español" className="nc_digital-lesson-button" disabled />
            )}
          </div>
        </div>
      </>
    </Dialog>
  );
};

export default DigitalLessonModal;
